import React from 'react';

import DetailsHeader from 'components/DetailsComponents/Header';

export default function Header() {
  return <DetailsHeader title="Notification Settings Center" breakWordOnly />;
}
